export const HAA = 'HardAssetsAlliance';
export const GS = 'GoldSilver';
export const GBI = 'GBIDirect';
export const CONTOSO = 'Contoso';
export const LPM = 'LPM';
